import PropTypes from 'prop-types';

import { BOOKING_STATUSES } from '../utils/constants';

import instantBookingShape from './instantBooking';

export default {
  bookingAcceptanceMaxDays: PropTypes.number,
  bookingStatus: PropTypes.oneOf(Object.values(BOOKING_STATUSES)).isRequired,
  className: PropTypes.string,
  hasGAP: PropTypes.bool,
  href: PropTypes.string,
  instantBooking: PropTypes.shape(instantBookingShape),
  maxStay: PropTypes.number,
  minStay: PropTypes.number,
  moveIn: PropTypes.string,
  moveInDatesRanges: PropTypes.array,
  moveOut: PropTypes.string,
  onClickBookNowButton: PropTypes.func.isRequired,
  onClickSuccessBookNowButton: PropTypes.func,
  rentableUnitId: PropTypes.number.isRequired,
  unavailabilities: PropTypes.array,
  isBookNowCardRedesign: PropTypes.bool,
  hasOffer: PropTypes.bool,
  checkAvailabilityTransId: PropTypes.string
};
